import React from 'react';
import styled from "styled-components";
import { asset } from '../../../utils/misc';

const MarqueeRow = styled.div`
  overflow: hidden;
  white-space: nowrap;
  width: 360px;
  position: relative;
  margin: 2rem -2rem 0;
`;

const MarqueeTrack = styled.div<{ direction?: 'left' | 'right' }>`
  display: inline-flex;
  gap: 10px;
  animation: ${props => props.direction === 'right' ? 'marquee-right' : 'marquee-left'} 30s linear infinite;

  @keyframes marquee-left {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }

  @keyframes marquee-right {
    0% {
      transform: translateX(-50%);
    }
    100% {
      transform: translateX(0);
    }
  }
`;

const Item = styled.div`
  border-radius: 12px;
  object-fit: cover;
  width: auto;
  height: 122px;
  aspect-ratio: 256 / 368;
  user-select: none;
  pointer-events: none;
  background: #c0324a;
  border-radius: 1rem;
  overflow: hidden;
`;

const ImageItem = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Marquee = ({ className, images, direction = 'left' }: { className?: string, images: string[], direction?: 'left' | 'right' }) => {
  const doubled = [...images, ...images];

  return (
    <MarqueeRow className={className}>
      <MarqueeTrack direction={direction}>
        {doubled.map((src, i) => (
          <Item key={i} className="testtest">
            {src && <ImageItem src={asset(`/dist/images/year-recap/posters/${src}.jpg`)} alt="" />}
          </Item>
        ))}
      </MarqueeTrack>
    </MarqueeRow>
  );
};